<template>
<div class="admin__ftpdata">
  <b-modal :id="this.modalID"
           :title="$t(this.modalTitle)"
           :ok-title="$t(this.modalOK)"
           :cancel-title="$t('Cancel')"
           @show="handleShow"
           @ok="handleOk">
    <div>
        {{$t('Are you sure you want to disable')}} {{ this.ftp.user.username }}?
    </div>
  </b-modal>
</div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'FTPDisableModal',
  props: {
    ftp: [Object, Boolean]
  },
  computed: {
    ID () {
      if (!this.ftp) {
        return 'disable-'
      }
      return `${this.ftp.id}-`
    },
    modalID () {
      return `disable-ftp-${this.ftp.id}`
    },
    modalTitle () {
      return `${this.$t('Disable FTP')}: ${this.ftp.user.username}`
    },
    modalOK () {
      return this.$t('Disable')
    }
  },
  methods: {
    ...mapActions({
      deleteFTP: 'admin/deleteFTP',
      fetchFTPs: 'admin/fetchFTPs'
    }),
    handleOk (event) {
      event.preventDefault()
      this.deleteFTP(this.ftp.id).then(response => {
        this.handleResponse(response)
      })
    },
    handleResponse (response) {
      if (response.status === 'ok') {
        // TO-DO: Display success notification
        this.fetchFTPs()
        this.$nextTick(() => {
          this.$bvModal.hide(this.modalID)
        })
      }
    },
    handleShow () {
      Object.assign(this.$data, this.$options.data.apply(this))
    }
  }
}
</script>

<style lang="scss">

</style>
